<template>
  <FormDocument type="Note de crédit" api-type="credit-notes" credit-note />
</template>

<script>
import FormDocument from '@/components/Form/Document'
export default {
  components: {
    FormDocument,
  },
  theme() {
    return {
      title: 'Ajouter une note de crédit',
      subtitle: '',
    }
  },
}
</script>

<style></style>
